import { c as _c } from "react/compiler-runtime";
import { LayoutChildSkeleton } from '@app/registration/(with-padding)/_components/layoutChildSkeleton';
import { Skeleton } from '@internations/ds';
import { ReactElement } from 'react';
export default function RegistrationPageSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><div><Skeleton height="40px" /></div><LayoutChildSkeleton /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}